import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Modal, notification, Row } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { DateTimeFormat, DateTimeFormatSimples } from '../../models/datetime'
import styles from './Retail.module.css'
import { getRecipeAdapterMsgAsync } from './retailSlice'
import leftImageUrl from './images/leftImg.png'
import rightImageUrl from './images/rightImg.png'
import { finishWpWaitUploadAsync } from '../treatment/editor/recipeListEditorSlice'
import { send } from '../../services/request'
import { debounce } from 'lodash'

export const DiagnosisAndPrescriptionModal = (props: {
  treatmentId?: any
  time?: any
  visible?: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [currentIndex, setCurrentIndex] = useState(0)

  const [displayedItems, setDisplayedItems] = useState<any>([])

  const [form] = Form.useForm()

  const [dataList, setDataList] = useState<any>()

  const [lastData, setLastData] = useState<any>()

  const [disabled, setDisabled] = useState<any>()

  const [loading, setLoading] = useState(false)

  const getMessage = (id?: any, list?: any) => {
    dispatch(
      getRecipeAdapterMsgAsync({
        treatmentId: Number(props?.treatmentId),
        id: id || 0,
      })
    )
      .then(unwrapResult)
      .then((v) => {
        const data = v?.map((n: any) => {
          return { ...n, flag: 1 }
        })
        const concatData = list
          ?.map((n: any) => {
            return {
              ...n,
              flag: n?.flag ? n?.flag : 1,
            }
          })
          ?.concat(data)
        setDataList(list?.length ? concatData : data)
        // 获取数组中的最后一条数据
        const lastData = v?.[v?.length - 1]
        setLastData(lastData)
        if (lastData?.isFinish) {
          setDisabled(true)
        } else {
          setDisabled(false)
        }
      })
  }
  useEffect(() => {
    if (props?.visible) {
      getMessage()
    } else {
      setDisabled(false)
      setLastData({})
      setDisplayedItems([])
      setDataList([])
      setCurrentIndex(0)
    }
  }, [props?.visible])

  useEffect(() => {
    if (dataList?.length)
      if (currentIndex < dataList?.length) {
        const nextItem = dataList[currentIndex]
        if (nextItem.flag === 1) {
          const timer = setTimeout(() => {
            setDisplayedItems((prev: any) => [...prev, dataList[currentIndex]])
            setCurrentIndex((prev) => prev + 1)
          }, 1000) // 1000毫秒 = 1秒
          return () => clearTimeout(timer)
        } else {
          setDisplayedItems((prev: any) => [...prev, nextItem])
          setCurrentIndex((prev) => prev + 1)
        }
      }
  }, [currentIndex, dataList])

  const send = debounce((inputData?: any) => {
    if (lastData?.anserKey?.includes(inputData)) {
      const data = { msg: inputData, flag: 2 }
      setDataList(dataList?.concat(data))
      getMessage(lastData?.id, dataList?.concat(data))
      form.resetFields()
    } else {
      Modal.info({
        centered: true,
        title: '确认操作',
        width: 600,
        content: <div>本次问诊内容不符合用药需求，问诊结束</div>,
        okText: '确认',
        cancelText: '取消',
        icon: null,
        onOk: () => {
          props?.onCancel()
          form.resetFields()
        },
      })
    }
  }, 300)

  return (
    <Modal
      title='处方申请'
      width={800}
      visible={props?.visible}
      onOk={() => {
        props?.onOk()
      }}
      onCancel={() => {
        props?.onCancel()
      }}
      footer={null}
      className={styles.modalBodyStyle}
    >
      <div className={styles.modalContent}>
        <div className={styles.modalContentTop}>
          <div className={styles.times}>
            {props?.time
              ? moment(props?.time).format(DateTimeFormatSimples)
              : ''}
          </div>
          {displayedItems?.map((v: any) => {
            return (
              <>
                {v?.flag == 1 ? (
                  <div className={styles.leftMessageMain}>
                    <div className={styles.headImg}>
                      <img
                        src={leftImageUrl}
                        alt='avatar'
                        style={{ width: '100%' }}
                      />
                    </div>
                    <div className={styles.text}>{v?.msg}</div>
                  </div>
                ) : (
                  <div className={styles.rightMessageMain}>
                    <div className={styles.textRight}>{v?.msg}</div>
                    <div className={styles.headImgRight}>
                      <img
                        src={rightImageUrl}
                        alt='avatar'
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                )}
              </>
            )
          })}
        </div>
        <div className={styles.modalContentBottom}>
          <div style={{ marginTop: '10px', display: 'flex' }}>
            <Button
              className={disabled ? styles.disabledButtons : styles.yesButton}
              disabled={disabled}
              onClick={() => {
                if (dataList?.length == currentIndex) {
                  send('是')
                } else {
                  return
                }
              }}
            >
              是
            </Button>
            <Button
              className={disabled ? styles.disabledButtons : styles.notButton}
              disabled={disabled}
              onClick={() => {
                if (dataList?.length == currentIndex) {
                  send('否')
                } else {
                  return
                }
              }}
            >
              否
            </Button>
          </div>
          <Form form={form}>
            <Row className={styles.modalContentBottomMain}>
              <div className={styles.modalContentBottomLeft}>
                <Col className={styles.titlesName}>用户</Col>
                <Col className={styles.inputStyle}>
                  <Form.Item name='message'>
                    <Input
                      placeholder='请输入'
                      style={{ width: '570px' }}
                      disabled={disabled}
                      onPressEnter={(v: any) => {
                        send(v?.target?.value)
                      }}
                    />
                  </Form.Item>
                </Col>
              </div>
              <Button
                className={disabled ? styles.disabledButton : styles.sendButton}
                disabled={disabled}
                onClick={() => {
                  const inputData = form.getFieldValue('message')
                  send(inputData)
                }}
              >
                发送
              </Button>
            </Row>
          </Form>
        </div>
      </div>
      <Row
        style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
        className={styles.buttons}
      >
        <Button
          type='primary'
          ghost
          style={{ marginRight: '10px' }}
          onClick={() => {
            props?.onCancel()
          }}
        >
          取消
        </Button>
        <Button
          loading={loading}
          type='primary'
          onClick={() => {
            Modal.confirm({
              centered: true,
              title: '确认操作',
              width: 600,
              content: <div>请再次核对诊断与处方信息是否正确。</div>,
              okText: '确认',
              cancelText: '取消',
              icon: null,
              onOk: () => {
                setLoading(true)
                dispatch(finishWpWaitUploadAsync(props?.treatmentId))
                  .then(unwrapResult)
                  .then(() => {
                    setLoading(false)
                    notification.success({ message: '已提交开方申请。' })
                    props?.onOk()
                  })
                  .catch((e) => {
                    setLoading(false)
                  })
              },
            })
          }}
        >
          问诊结束
        </Button>
      </Row>
    </Modal>
  )
}
